import { ParsedUrlQuery } from 'querystring';

const getParam = (params: ParsedUrlQuery | undefined, key: string) => {
    const value = params && params[key];

    if (value && typeof value === 'string') {
        return value;
    }

    return null;
};

export { getParam };
